import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import SectionTree from "./SectionTree";
import SectionSearch from "./SectionSearch";
import SectionSearchResult from "./SectionSearchResult";
import { StoreContext } from "../stores/contexts";

class SectionsTreeApp extends Component {
  static contextType = StoreContext;

  componentDidMount() {

  }

  render() {

    return (
      <div className="up12 splice h100">
        <div className="cell s-12">
          <div style={{height:50}}>
            {/*this.context.treeStore.title?(
              <div className="w1 ttu bold vpadd10 hpadd15 fs13">
                {this.context.treeStore.title}
              </div>
            ):null*/}

            <div className="hpadd10 bg-w4 up12 splice innerMenuTitle">
              <div className="up12 splice">
                {this.context.searchStore.search_query || this.props.disable_controlls?null:(
                  <div className="cell s-shrink  s-middle pright5">
                    <i onClick={()=>{ this.context.communicatorStore.pushMessage({ type:'output', command:'back_button' }) }} className={`pointer rad4  hpadd5 mdi mdi-arrow-left fs24 b1 bg-b4-hover w1-hover`}></i>
                  </div>
                )}
                <div className={`cell s-auto s-middle ${this.context.searchStore.search_query || this.props.disable_controlls?'hpadd10':''}`}>
                  <SectionSearch />
                </div>
                {this.context.searchStore.search_query || this.props.disable_controlls?null:(
                  <div className="cell s-shrink  s-middle pleft5">
                    <i className={`pointer rad4  hpadd5 mdi mdi-sort fs24  ${this.context.dragStore.drag_enabled?'bg-b1 w1':'bg-b4-hover b1'}`} onClick={()=>{ this.context.dragStore.toggleDrag(); }}></i>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="cell s-12 sectionsRoot ofa" style={{height: 'calc(100vh - 50px)'}}>
            {this.context.searchStore.search_query?(
              <SectionSearchResult />
            ):(
              <SectionTree section={0} level={1} />
            )}
        </div>
        {this.context.searchStore.section_locating?(
          <div className="pa pa-tl w100 h100 bg-b1-op50"></div>
        ):false}
      </div>
    )
  }
}

// export default inject("treeStore","searchStore","dragStore","communicatorStore")(observer(SectionsTreeApp));
export default observer(SectionsTreeApp);